import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsCanalVendaClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/canal-venda');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as CanalVenda');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/canal-venda', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as CanalVenda');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/canal-venda', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as CanalVenda');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/canal-venda/findOne/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a CanalVenda');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.post('/canal-venda/update', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a CanalVenda');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/canal-venda/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a CanalVenda');
    }
  }
}
